import * as _m from '@/models';
import { Swiper, SwiperSlide } from 'swiper/react';
import React from 'react';
import { Link } from 'react-router-dom';
import { useChannels } from '@/hooks/api/useChannels';

export const Channels = () => {
  const { data: channels } = useChannels();

  return (
    <section className="covers x2">
      <h2 className="section-title">Heaven Channel</h2>
      <Swiper slidesPerView={'auto'} centeredSlides={false}>
        {channels?.map((c) => (
          <SwiperSlide key={`${c.id}`}>
            <Link to={`/channels/${c.cid}`} className="swiper-slide">
              <div className="wrapper">
                <img src={c.profile_image_url} className="cover" loading={'lazy'} />
                <img src={c.icon_url} className="icon" loading={'lazy'} />
              </div>
              <div className="content">
                <div className="name">{c.name}</div>
                <div className="count"></div>
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};
